import "./topbar.css"
import { useContext, useEffect, useState } from "react";
import {Link} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";
import { ConnectionState } from "../../socket/ConnectionState";

export default function Topbar({ connectionState, selectedMission, isMissionDragging }) {
  const { user } = useContext(AuthContext);

  return (
    <div className="topbarContainer">
      <div className="topbarLeft">
        <Link to="/" style={{textDecoration:"none"}}>
          <span className="logo">FDT - LK Leer</span>
        </Link>
      </div>
      <div className="topbarCenter">
        <p>{selectedMission ? "Ausgewählter Einsatz " + selectedMission.keyword : "kein Einsatz ausgewählt"}</p>
        <p>{isMissionDragging ? "Dragging" : "noDragging"}</p>
      </div>
      <div className="topbarRight">
        <div className="topbarLinks">
          <Link to="/admin" className="topbarLink">Admin</Link>
          <Link to="/status" className="topbarLink">Status</Link>
        </div>
        <div className="topbarIcons">
          <p>{connectionState ? "Verbunden" : "Getrennt" }</p>
        </div>
      </div>
    </div>
  )
}
